import { Box, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import EraserImage from "../../../../assets/Knowledge/images/knowledge-eraser.png";
import RemoveBgImage from "../../../../assets/Knowledge/images/knowledge-remove-bg.jpg";
import LinkConstants from "../../../../constants/LinkConstants";
import styles from "./KnowledgeCard.module.scss";

export type KnowledgeCardOption = keyof typeof LinkConstants.KNOWLEDGE;

const cardsImageMap: Record<KnowledgeCardOption, string> = {
	REMOVE_BG: RemoveBgImage,
	ERASER: EraserImage,
};

export type KnowledgeCardProps = {
	card: KnowledgeCardOption;
	className?: string;
};

const KnowledgeCard = ({ card, className }: KnowledgeCardProps) => {
	const { t } = useTranslation("translation", { keyPrefix: "knowledgeCards" });
	const openDocs = (link: string) => window.open(link, "_blank");

	return (
		<Box
			className={`${styles.cardContainer} ${className || ""}`}
			onClick={() => openDocs(LinkConstants.KNOWLEDGE[card])}
		>
			<Box className={styles.imgContainter}>
				<img className={styles.image} src={cardsImageMap[card]} alt={card} />
			</Box>
			<Box className={styles.textAndButtonContainer}>
				<Trans>
					<Typography className={styles.title}>{t(`${card}.title`)}</Typography>
					<Typography className={styles.description}>{t(`${card}.description`)}</Typography>
				</Trans>
			</Box>
		</Box>
	);
};

export default KnowledgeCard;
